import { getAuthCentral } from "../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import addLogDocument from "./addLogDocument";

// Function to send error message to Discord
const sendErrorDiscord = async (message, prefix) => {
  // Define the endpoint URL
  try {
    const url = prefix + "send/react-error";

    // Define the request body
    const body = {
      message: message,
    };

    const headers = {
      "Content-Type": "application/json",
    };

    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return;
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);

    // Retrieve the organization reference from the user document
    const userSnapshot = await getDoc(userRef);

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return;
    }

    const orgRef = userSnapshot.get("org_ref");

    // Add log document (Assuming you have a similar function for adding logs in JavaScript)
    await addLogDocument(
      url,
      prefix,
      userRef,
      orgRef,
      response.status.toString(),
      "",
      "",
      JSON.stringify(body), // Log the request body
      await response.text() // Log the response body as text
    );

    // Check if the request was successful
    if (response.ok) {
    } else {
      console.error(`Failed to send error: ${response.status}`);
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
  }
};

export default sendErrorDiscord;
